export default __webpack_public_path__ + "static/media/karatekid.d8008798.png";